import { useState } from 'react';
import DataTable from '../../components/DataTable';
import { formatDate } from '../../utils/formatters';
import ReportDialog, { STATUS_OPTIONS, SUBJECT_LABELS } from './ReportDialog';

const PlaceIssueReportsPage = ({
  reports,
  filters,
  setFilters,
  loadReports,
  onSaveReport,
  loading,
}) => {
  const [selectedReport, setSelectedReport] = useState(null);

  const columns = [
    { key: 'reportId', label: 'מזהה', render: (report) => report.reportId },
    { key: 'placeName', label: 'מקום', render: (report) => report.placeName },
    {
      key: 'subject',
      label: 'נושא',
      render: (report) => SUBJECT_LABELS[report.subject] || report.subject,
    },
    { key: 'reporterName', label: 'מדווח', render: (report) => report.reporterName },
    { key: 'phone', label: 'טלפון', render: (report) => report.phone },
    {
      key: 'status',
      label: 'סטטוס',
      render: (report) => (
        <span className={`pill issue-${report.status.toLowerCase()}`}>
          {STATUS_OPTIONS.find((item) => item.value === report.status)?.label || report.status}
        </span>
      ),
    },
    { key: 'createdAt', label: 'נוצר', render: (report) => formatDate(report.createdAt) },
  ];

  return (
    <section className="work-area table-page" dir="rtl">
      <header className="section-header">
        <div>
          <h1>דיווחים על מקומות</h1>
          <span>{reports.total} דיווחים</span>
        </div>
        <div className="filters issue-filters">
          <input
            placeholder="חיפוש לפי מזהה, מקום, שם או טלפון"
            value={filters.issueSearch}
            onChange={(event) => setFilters({ ...filters, issueSearch: event.target.value })}
          />
          <select
            value={filters.issueStatus}
            onChange={(event) => setFilters({ ...filters, issueStatus: event.target.value })}
          >
            <option value="">כל הסטטוסים</option>
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <select
            value={filters.issueSubject}
            onChange={(event) => setFilters({ ...filters, issueSubject: event.target.value })}
          >
            <option value="">כל הנושאים</option>
            {Object.entries(SUBJECT_LABELS).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <button onClick={() => loadReports(1)}>סינון</button>
        </div>
      </header>

      <DataTable
        columns={columns}
        items={reports.items}
        rowKey={(report) => report.reportId}
        onRowClick={setSelectedReport}
        page={reports.page}
        limit={reports.limit}
        total={reports.total}
        onPageChange={loadReports}
        loading={loading}
      />

      <ReportDialog
        report={selectedReport}
        open={Boolean(selectedReport)}
        onClose={() => setSelectedReport(null)}
        onSave={onSaveReport}
        loading={loading}
      />
    </section>
  );
};

export default PlaceIssueReportsPage;
